import React from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import FieldTitle from 'components/aor/FieldTitle';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import Table from 'components/ui/table/Table';
import TableBodyCell from 'components/table/TableBodyCell';
import TableRow from 'components/ui/table/TableRow';
import TextField from 'components/show/TextField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import StatusLabelField from 'components/show/StatusLabelField';
import theme from 'theme/theme';
import NoResults from 'components/form/styling/NoResults';
import { isEmpty } from 'lodash';
import dateUtils from 'helpers/dateUtils';
import Loader from 'components/loading/Loader';
import SingleDataTextField from 'components/show/SingleDataTextField';
import { fetchProductMembership } from 'store/actions/product-memberships/fetchProductMemberships';
import { deleteUserProductMembership } from 'store/actions/users/product-memberships/deleteUserProductMembership';
import { fetchUserProductMembershipPool } from 'store/actions/users/product-membership-pool/fetchUserProductMembershipPool';

const UserProductMembershipsList = (props) => {
    const {
        isLoading,
        memberships,
        refetchProductMemberships,
        resource,
        translate,
    } = props;

    const isActiveMembership = (membership) => {
        if (membership.starts_at && membership.ends_at) {
            return dateUtils.isBefore(dateUtils.stringToDate(membership.starts_at), new Date()) &&
                dateUtils.isAfter(dateUtils.stringToDate(membership.ends_at), new Date());
        }

        if (membership.starts_at) {
            return dateUtils.isBefore(dateUtils.stringToDate(membership.starts_at), new Date());
        }

        return false;
    };

    if (isLoading) {
        return <Loader size={ 25 } />;
    }

    if (isLoading || isEmpty(memberships)) {
        return <NoResults label={ translate('resources.product_memberships.no_results') } />;
    }

    return (
        <Table responsive='scroll'>
            <TableRow>
                <HeaderColumn style={ { width: '20%' } }>
                    <FieldTitle
                        label='filters.components.product_membership_id.label'
                        resource={ resource }
                        source='relationships.memberships.data.name'
                    />
                </HeaderColumn>
                <HeaderColumn>
                    <FieldTitle
                        label='fields.price'
                        resource={ resource }
                        source='relationships.memberships.data.price'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '20%' } }>
                    <FieldTitle
                        label='filters.components.user_product_membership_pool_id.label'
                        resource={ resource }
                        source='relationships.memberships.data.user_product_membership_pool_id'
                    />
                </HeaderColumn>
                <HeaderColumn>
                    <FieldTitle
                        label='Payment Method'
                        resource={ resource }
                        source='relationships.memberships.data.payment_method'
                    />
                </HeaderColumn>
                <HeaderColumn>
                    <FieldTitle
                        label='filters.components.status.label'
                        resource={ resource }
                        source='relationships.memberships.data.active'
                    />
                </HeaderColumn>
                <HeaderColumn>{ translate('resources.orders.receipt.options') }</HeaderColumn>
            </TableRow>

            { utils.map(memberships, function (membership) {
                const isActive = isActiveMembership(membership);

                const statusBackground = isActive ? theme.palette.mossGreen : theme.palette.tomato;
                const statusLabel = translate(isActive ? 'resources.access_methods.list.active' : 'resources.access_methods.list.inactive');

                return (
                    <TableRow
                        key={ membership.id }
                    >
                        <TableBodyCell
                            field={
                                <SingleDataTextField
                                    action={ fetchProductMembership }
                                    link={ true }
                                    optionValue='name'
                                    source='product_membership_id'
                                />
                            }
                            record={ membership }
                            resource='product-memberships'
                        />

                        <TableBodyCell
                            field={ <TextField value={ utils.formatPrice(membership.price, membership.currency) } /> }
                            record={ membership }
                            source='price'
                        />

                        <TableBodyCell
                            field={
                                <SingleDataTextField
                                    action={ fetchUserProductMembershipPool }
                                    optionValue='name'
                                    source='user_product_membership_pool_id'
                                />
                            }
                            record={ membership }
                            resource='user-product-membership-pool'
                        />

                        <TableBodyCell
                            field={ <TextField value={ membership.payment_method } /> }
                            record={ membership }
                            source='payment_method'
                        />

                        <TableBodyCell
                            field={ <StatusLabelField label={ statusLabel } background={ statusBackground } /> }
                            record={ membership }
                        />

                        <TableBodyCell
                            field={
                                <DropDownActionsMenu
                                    column={ {
                                        align: 'center',
                                        link: false,
                                        width: '10%',
                                    } }
                                    resource={ resource }
                                >
                                    <EditAction />

                                    <DeleteAction
                                        action={ deleteUserProductMembership }
                                        params={ {
                                            id: membership.id,
                                            onSuccess: refetchProductMemberships,
                                        } }
                                    />
                                </DropDownActionsMenu>
                            }
                            record={ membership }
                            resource={ resource }
                        />
                    </TableRow>
                );
            }) }
        </Table>
    );
};

UserProductMembershipsList.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    memberships: PropTypes.array,
    refetchProductMemberships: PropTypes.func.isRequired,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(UserProductMembershipsList);


// WEBPACK FOOTER //
// ./src/pages/users/product-memberships/UserProductMembershipsList.js